import { AiFillGithub, AiFillYoutube } from "react-icons/ai";
import { netdroidLogo, pdfunlockerLogo, tempmailLogo } from './images';

export const menu = [
  { name: "About" },
  { name: "Services" },
  { name: "Projects" },
  { name: "Contact" },
]

export const projects = [
  {
    id: 1,
    title: 'NetDroid – All Network Tools',
    image: netdroidLogo,
    category: "Apps",
    rating: 4.2,
    data: {
      description: `Your all-in-one network toolkit with 25+ powerful tools including Speed Test, Ping, WiFi Analyzer, Port Checker, DNS Lookup, Traceroute, and more. Perfect for network administrators and tech enthusiasts who need reliable diagnostics on the go.`,
      demoLink: "https://play.google.com/store/apps/details?id=com.ragnar.netdroid",
    },
  },
  {
    id: 2,
    title: 'PDF Unlocker',
    image: pdfunlockerLogo,
    category: "Apps",
    rating: 3.4,
    data: {
      description: `Unlock password-protected PDF files instantly and offline. Remove restrictions from secured PDFs to enable printing, copying, and editing. A simple, fast, and privacy-focused utility — no internet connection required.`,
      demoLink: "https://play.google.com/store/apps/details?id=com.ragnarservers.pdfunlocker",
    },
  },
  {
    id: 3,
    title: 'Temp Mail - Disposable Email',
    image: tempmailLogo,
    category: "Apps",
    rating: 5.0,
    data: {
      description: `Create temporary email addresses instantly with no signup required. Protect your privacy from spam and unwanted emails. Features include auto-delete after 12 hours, multiple domain support, custom email prefix, and full attachment support.`,
      demoLink: "https://play.google.com/store/apps/details?id=com.ragnar.tempmailget",
    },
  },
  {
    id: 4,
    title: 'TempMailGet',
    image: 'https://www.tempmailget.com/favicon.svg',
    category: "Web",
    rating: null,
    data: {
      description: `A free temporary email web service — generate disposable email addresses instantly without registration. Receive emails privately, protect your real inbox, and stay organized. Works with any website. Mobile-friendly with attachment support.`,
      demoLink: "https://tempmailget.com/",
    },
  },
  {
    id: 5,
    title: 'Ragnar Servers',
    image: 'https://i.postimg.cc/3RdyrSCv/snapedit-1736771901291.png',
    category: "Community",
    rating: null,
    data: {
      description: `The Ragnar Servers Telegram channel is a central hub for tech enthusiasts, providing high-speed internet configuration files, premium service giveaways, and exclusive tech content. No shortened links — just direct, smooth access to everything you need.`,
      demoLink: "https://t.me/ragnarservers",
    },
  },
]


export const socialHandles = [
  {
    name: "Github",
    icon: <AiFillGithub />,
    link: "https://github.com/AnimeHolic",
  },
  {
    name: "Youtube",
    icon: <AiFillYoutube />,
    link: "https://www.youtube.com/@RagnarServers",
  },
];
